const rtf = typeof Intl !== 'undefined' ? new Intl.RelativeTimeFormat('de-DE', { numeric: 'auto' }) : null;

function formatSameDay(d: Date, now: Date): string {
  const time = d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
  if (d.toDateString() === now.toDateString()) return `Heute, ${time}`;
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) return `Gestern, ${time}`;
  return d.toLocaleDateString('de-DE', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}

/** Pipedrive-style short label for notification timestamps. */
export function formatNotificationTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  const diffMs = d.getTime() - now.getTime();
  const diffMin = Math.round(diffMs / 60_000);
  if (Math.abs(diffMin) < 60 && rtf) {
    return rtf.format(diffMin, 'minute');
  }
  const diffHours = Math.round(diffMs / 3_600_000);
  if (Math.abs(diffHours) < 24 && rtf) {
    return rtf.format(diffHours, 'hour');
  }
  return formatSameDay(d, now);
}
